import { render } from "./attendee.vue?vue&type=template&id=00c23cde"
import script from "./attendee.vue?vue&type=script&lang=js"
export * from "./attendee.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__